import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Form, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT, formatDate } from '@angular/common';
import { AppConstants, Company, ICompany, IResponse, ISearch, IUIRender, IUser } from 'src/app/models';
import { IBinnacle } from 'src/app/models/i-binnacle';
import { AlertService, BinnacleService, UserService } from 'src/app/services';
import { BlockUIHandlerService, CompanyService } from 'src/app/common/services.index';
import { ALERTS } from 'src/app/common/enums';
import { NgbModal, NgbModalRef, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {
  //VARBOX
  companyForm: FormGroup;
  modalReference: NgbModalRef;
  isOnEditMode: boolean;
  companies: ICompany[];
  constructor(
    private companyService: CompanyService
    , private blockUIHandler: BlockUIHandlerService
    , private modalService: NgbModal
    , private formBuilder: FormBuilder
    , private alertService: AlertService
  ) { }

  InitVarialbes(): void {
    this.isOnEditMode = false;
    this.companies = [];
  }

  ngOnInit(): void {
    this.GetCompanies();
  }

  GetCompanies(): void {
    this.blockUIHandler.Start(1, `Procesando, espere por favor`);
    this.companyService.GetCompanies().pipe(
      finalize(() => this.blockUIHandler.Stop())
    ).subscribe(next => {
      if (next?.Result && next.Data.length > 0) {
        this.companies = next.Data;
      }
      else {

      }
    }, error => {
      console.log(error);
    });
  }

  GetCompany(_id: number): void {
    this.isOnEditMode = true;
  }

  RaiseCompanyModal(_id: number, content, _isOnEditMode = true,): void {
    this.isOnEditMode = _isOnEditMode;
    this.ResetCompanyForm();
    if (_isOnEditMode) {
      this.blockUIHandler.Start(1);
      this.companyService.GetCompany(_id).subscribe(next => {
        if (next?.Result) {
          this.companyForm.patchValue({ ...next.Data });
          this.modalReference = this.modalService.open(content,
            {
              centered: true,
              backdrop: 'static'
            });
        }
        else {
          this.alertService.ShowSmallCornerAlert(next.ErrorInfo?.Message, ALERTS.info);
        }
      }, error => {
        this.blockUIHandler.Stop();
        console.log(error.error);
      }, () => {
        this.blockUIHandler.Stop();
      });
    }
    else {
      this.companyForm.patchValue({ Active: true });
      this.modalReference = this.modalService.open(content,
        {
          centered: true,
          backdrop: 'static'
        });
    }
  }


  DismissCompanyModal(): void {
    this.modalReference.close();
  }

  ResetCompanyForm(): void {
    this.companyForm = this.formBuilder.group({
      Id: [-1],
      Name: ['', Validators.required],
      Active: [true, Validators.required],
      UseRemoteService: [false],
      RemoteServiceUrl: [{value: '', disabled: true}],
      ReportsPath: [{value: '', disabled: true}]
    });

    // Suscribirse a los cambios del checkbox UseRemoteService
    this.companyForm.get('UseRemoteService').valueChanges.subscribe(value => {
      if (value) {
        this.companyForm.get('RemoteServiceUrl').enable();
        this.companyForm.get('ReportsPath').enable();
      } else {
        this.companyForm.get('RemoteServiceUrl').disable();
        this.companyForm.get('ReportsPath').disable();
        this.companyForm.patchValue({
          RemoteServiceUrl: '',
          ReportsPath: ''
        });
      }
    });
  }

  OnNavChange(changeEvent: NgbNavChangeEvent): void {

  }

  Store(): void {
    const COMPANY = this.companyForm.getRawValue() as ICompany;

    if (!COMPANY.Name) {
      this.alertService.ShowBigCenteredAlert(`El nombre de la compañía es requerido`, ALERTS.info);
      return;
    }

    if (COMPANY.UseRemoteService) {
      if (!COMPANY.RemoteServiceUrl || COMPANY.RemoteServiceUrl.trim() === '') {
        this.alertService.ShowBigCenteredAlert(`La URL del servicio remoto es requerida cuando se utiliza servicio para generación de reportes`, ALERTS.info);
        return;
      }
      if (!COMPANY.ReportsPath || COMPANY.ReportsPath.trim() === '') {
        this.alertService.ShowBigCenteredAlert(`La ruta de reportes es requerida cuando se utiliza servicio para generación de reportes`, ALERTS.info);
        return;
      }
    }

    this.isOnEditMode ? this.UpdateCompany() : this.CreateCompany();
  }

  CreateCompany(): void {
    const COMPANY = this.companyForm.getRawValue() as ICompany;

    this.blockUIHandler.Start(1, `Procesando, espere por favor`);
    this.companyService.CreateCompany(COMPANY).subscribe(next => {
      this.blockUIHandler.Stop();
      try {
        if (next?.Result) {
          this.alertService.ShowSmallCornerAlert(`Procesado con éxito`, ALERTS.success);
          this.DismissCompanyModal();
          this.ResetCompanyForm();
          this.GetCompanies();
        }
        else {
          this.alertService.ShowBigCenteredAlert(AppConstants.GetError(next), ALERTS.error);
        }
      }
      catch (error) {
        this.alertService.ShowBigCenteredAlert(error, ALERTS.error);
        console.info(error);
      }
    }, error => {
      this.blockUIHandler.Stop();
      this.alertService.ShowBigCenteredAlert(AppConstants.GetError(error), ALERTS.error);
      console.info(error);
    });
  }

  UpdateCompany(): void {
    const COMPANY = this.companyForm.getRawValue() as ICompany;
    this.blockUIHandler.Start(1, `Procensando, espere por favor`);
    this.companyService.UpdateCompany(COMPANY).subscribe(next => {
      this.blockUIHandler.Stop();
      try {
        if (next?.Result) {
          this.alertService.ShowSmallCornerAlert(`Procesado con éxito`, ALERTS.success);
          this.DismissCompanyModal();
          this.ResetCompanyForm();
          this.GetCompanies();
        }
      }
      catch (error) {
        this.alertService.ShowBigCenteredAlert(error, ALERTS.error);
        console.info(error);
      }
    }, error => {
      this.blockUIHandler.Stop();
      this.alertService.ShowBigCenteredAlert(error, ALERTS.error);
      console.info(error);
    });
  }
}